/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FindAllPreferences200Response,
  NotificationPreferenceDeliveryScope,
  NotificationPreferenceSettings,
  NotificationPreferencesUpdateRequest,
  PreferenceDeliveryScopeApplyToAllRequest,
  SuprSendGenerateJwtToken200Response,
  SuprSendJwtTokenRequest,
} from '../models/index';
import {
    FindAllPreferences200ResponseFromJSON,
    FindAllPreferences200ResponseToJSON,
    NotificationPreferenceDeliveryScopeFromJSON,
    NotificationPreferenceDeliveryScopeToJSON,
    NotificationPreferenceSettingsFromJSON,
    NotificationPreferenceSettingsToJSON,
    NotificationPreferencesUpdateRequestFromJSON,
    NotificationPreferencesUpdateRequestToJSON,
    PreferenceDeliveryScopeApplyToAllRequestFromJSON,
    PreferenceDeliveryScopeApplyToAllRequestToJSON,
    SuprSendGenerateJwtToken200ResponseFromJSON,
    SuprSendGenerateJwtToken200ResponseToJSON,
    SuprSendJwtTokenRequestFromJSON,
    SuprSendJwtTokenRequestToJSON,
} from '../models/index';

export interface ApplyDeliveryScopesToAllPreferencesRequest {
    preferenceDeliveryScopeApplyToAllRequest: PreferenceDeliveryScopeApplyToAllRequest;
}

export interface CreatePreferenceDeliveryScopeRequest {
    notificationPreferenceDeliveryScope: NotificationPreferenceDeliveryScope;
    selectAll?: boolean;
}

export interface CreatePreferenceSettingsRequest {
    notificationPreferenceSettings: NotificationPreferenceSettings;
}

export interface FindAllPreferencesRequest {
    userIds: string;
}

export interface SuprSendGenerateJwtTokenRequest {
    suprSendJwtTokenRequest: SuprSendJwtTokenRequest;
}

export interface UpdatePreferenceSettingsRequest {
    id: string;
    notificationPreferenceSettings: NotificationPreferenceSettings;
}

export interface UpdatePreferencesRequest {
    notificationPreferencesUpdateRequest: NotificationPreferencesUpdateRequest;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Copy delivery scopes from one notification preference to all others
     */
    async applyDeliveryScopesToAllPreferencesRaw(requestParameters: ApplyDeliveryScopesToAllPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.preferenceDeliveryScopeApplyToAllRequest === null || requestParameters.preferenceDeliveryScopeApplyToAllRequest === undefined) {
            throw new runtime.RequiredError('preferenceDeliveryScopeApplyToAllRequest','Required parameter requestParameters.preferenceDeliveryScopeApplyToAllRequest was null or undefined when calling applyDeliveryScopesToAllPreferences.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/preference-delivery-scopes/apply-to-all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PreferenceDeliveryScopeApplyToAllRequestToJSON(requestParameters.preferenceDeliveryScopeApplyToAllRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Copy delivery scopes from one notification preference to all others
     */
    async applyDeliveryScopesToAllPreferences(requestParameters: ApplyDeliveryScopesToAllPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.applyDeliveryScopesToAllPreferencesRaw(requestParameters, initOverrides);
    }

    /**
     * Create Notification Preference Delivery Scope
     */
    async createPreferenceDeliveryScopeRaw(requestParameters: CreatePreferenceDeliveryScopeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.notificationPreferenceDeliveryScope === null || requestParameters.notificationPreferenceDeliveryScope === undefined) {
            throw new runtime.RequiredError('notificationPreferenceDeliveryScope','Required parameter requestParameters.notificationPreferenceDeliveryScope was null or undefined when calling createPreferenceDeliveryScope.');
        }

        const queryParameters: any = {};

        if (requestParameters.selectAll !== undefined) {
            queryParameters['select_all'] = requestParameters.selectAll;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/preference-delivery-scopes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NotificationPreferenceDeliveryScopeToJSON(requestParameters.notificationPreferenceDeliveryScope),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create Notification Preference Delivery Scope
     */
    async createPreferenceDeliveryScope(requestParameters: CreatePreferenceDeliveryScopeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createPreferenceDeliveryScopeRaw(requestParameters, initOverrides);
    }

    /**
     * Create User Type Preference settings
     */
    async createPreferenceSettingsRaw(requestParameters: CreatePreferenceSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.notificationPreferenceSettings === null || requestParameters.notificationPreferenceSettings === undefined) {
            throw new runtime.RequiredError('notificationPreferenceSettings','Required parameter requestParameters.notificationPreferenceSettings was null or undefined when calling createPreferenceSettings.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/preference-settings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NotificationPreferenceSettingsToJSON(requestParameters.notificationPreferenceSettings),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create User Type Preference settings
     */
    async createPreferenceSettings(requestParameters: CreatePreferenceSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createPreferenceSettingsRaw(requestParameters, initOverrides);
    }

    /**
     * Get all preferences
     */
    async findAllPreferencesRaw(requestParameters: FindAllPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllPreferences200Response>> {
        if (requestParameters.userIds === null || requestParameters.userIds === undefined) {
            throw new runtime.RequiredError('userIds','Required parameter requestParameters.userIds was null or undefined when calling findAllPreferences.');
        }

        const queryParameters: any = {};

        if (requestParameters.userIds !== undefined) {
            queryParameters['user_ids'] = requestParameters.userIds;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/preferences`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllPreferences200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all preferences
     */
    async findAllPreferences(requestParameters: FindAllPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllPreferences200Response> {
        const response = await this.findAllPreferencesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate JWT token for SuprSend integration
     */
    async suprSendGenerateJwtTokenRaw(requestParameters: SuprSendGenerateJwtTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuprSendGenerateJwtToken200Response>> {
        if (requestParameters.suprSendJwtTokenRequest === null || requestParameters.suprSendJwtTokenRequest === undefined) {
            throw new runtime.RequiredError('suprSendJwtTokenRequest','Required parameter requestParameters.suprSendJwtTokenRequest was null or undefined when calling suprSendGenerateJwtToken.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/suprsend/generate-jwt-token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SuprSendJwtTokenRequestToJSON(requestParameters.suprSendJwtTokenRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuprSendGenerateJwtToken200ResponseFromJSON(jsonValue));
    }

    /**
     * Generate JWT token for SuprSend integration
     */
    async suprSendGenerateJwtToken(requestParameters: SuprSendGenerateJwtTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuprSendGenerateJwtToken200Response> {
        const response = await this.suprSendGenerateJwtTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update User Type Preference settings
     */
    async updatePreferenceSettingsRaw(requestParameters: UpdatePreferenceSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updatePreferenceSettings.');
        }

        if (requestParameters.notificationPreferenceSettings === null || requestParameters.notificationPreferenceSettings === undefined) {
            throw new runtime.RequiredError('notificationPreferenceSettings','Required parameter requestParameters.notificationPreferenceSettings was null or undefined when calling updatePreferenceSettings.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/preference-settings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: NotificationPreferenceSettingsToJSON(requestParameters.notificationPreferenceSettings),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update User Type Preference settings
     */
    async updatePreferenceSettings(requestParameters: UpdatePreferenceSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updatePreferenceSettingsRaw(requestParameters, initOverrides);
    }

    /**
     * Update User Type Preferences
     */
    async updatePreferencesRaw(requestParameters: UpdatePreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.notificationPreferencesUpdateRequest === null || requestParameters.notificationPreferencesUpdateRequest === undefined) {
            throw new runtime.RequiredError('notificationPreferencesUpdateRequest','Required parameter requestParameters.notificationPreferencesUpdateRequest was null or undefined when calling updatePreferences.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/preferences`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: NotificationPreferencesUpdateRequestToJSON(requestParameters.notificationPreferencesUpdateRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update User Type Preferences
     */
    async updatePreferences(requestParameters: UpdatePreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updatePreferencesRaw(requestParameters, initOverrides);
    }

}
